<div class="description">
    <div class="description__container" [ngSwitch]="brand">
        <ng-container *ngSwitchCase="'mv'">
            <ng-container *ngIf="type === 'travel'; else elseBlock">
                <p class="color-white size-1">
                    Offrir un voyage est un cadeau résolument… dépaysant ! Alors, quelle que soit l’occasion, afin que
                    son organisation soit parfaite, confiez-nous ce projet et nos experts trouveront le séjour idéal.
                </p>
                <p class="color-white size-1">
                    Grâce à un système de « cagnotte », le nombre de participants est illimité et vous pourrez suivre le
                    montant récolté en temps réel !
                </p>
            </ng-container>
            <ng-template #elseBlock>
                <p class="color-white size-1">
                    Emmener sa moitié vers de lointaines contrées ne s’improvise pas. Alors, pour votre lune de miel
                    soit aussi romantique qu’extraordinaire, faites confiance à notre agence de voyages sur-mesure.
                </p>
                <p class="color-white size-1">
                    Nos experts trouveront avec vous la destination idéale et vous composeront le séjour de vos rêves.
                    Cerise sur le gâteau, il est tout à fait possible de faire participer vos invités à la création de
                    votre voyage de noces !
                </p>
            </ng-template>
        </ng-container>
        <ng-container *ngSwitchCase="'pv'">
            <ng-container *ngIf="type === 'travel'; else elseBlock">
                <p class="color-white size-1">
                    Offrir ou se faire offrir un voyage est un projet qui mérite la plus grande attention. C’est donc
                    avec passion et dévouement que les conseillers Prestige Voyages construisent des séjours sur-mesure
                    pour une expérience unique.
                </p>
                <p class="color-white size-1">
                    Si vous êtes plusieurs à participer au financement, un système de « cagnotte » permet de suivre le
                    montant récolté en temps réel !
                </p>
            </ng-container>
            <ng-template #elseBlock>
                <p class="color-white size-1">
                    Maîtres dans l’art du voyage sur-mesure, les conseillers Prestige Voyages confectionnent des lunes
                    de miel cousues de fil d’or.
                </p>
                <p class="color-white size-1">
                    Ils mettent leur expertise à votre service et grâce à eux, votre voyage de noces sera digne des plus
                    beaux contes de fées. Selon vos préférences, il est également possible de réaliser ce projet sous
                    forme de liste de mariage.
                </p>
            </ng-template>
        </ng-container>
    </div>
</div>
